import React from "react";
import {useTranslation} from "react-i18next";

const Team = () => {
  const team = [
    {
      nombre: "Carlos",
      puesto: ["Team lead.", "Artist."],
      img: "carlos.png",
      socials: [
        {
          social: "twitter",
          link: "https://twitter.com/CarlosAdams_",
        },
        {
          social: "twitch",
          link: "https://www.twitch.tv/carlos_adams",
        },
        {
          social: "instagram",
          link: "https://www.instagram.com/carlos.adams/",
        },
      ],
    },
    {
      nombre: "Victor",
      puesto: ["Marketing.", "SEO."],
      img: "victor.png",
      socials: [
        {
          social: "twitter",
          link: "https://twitter.com/wallstwolverine",
        },
        {
          social: "youtube",
          link: "https://www.youtube.com/c/INVICTHOR",
        },
        {
          social: "instagram",
          link: "https://www.instagram.com/vittoriomalatesta/",
        },
      ],
    },
    {
      nombre: "Alexfu",
      puesto: ["Smart contract dev.", "Frontend web3 dev."],
      img: "alexfu.png",
      socials: [
        {
          social: "twitter",
          link: "https://twitter.com/Alexfu_tw",
        },
        {
          social: "instagram",
          link: "https://www.instagram.com/alexfu_01/",
        },
      ],
    },
    {
      nombre: "Jaime",
      puesto: ["Smart contract dev.", "Art engine dev."],
      img: "jommys.png",
      socials: [
        {
          social: "instagram",
          link: "https://www.instagram.com/eljommys/",
        },
        {
          social: "github",
          link: "https://github.com/eljommys",
        },
        {
          social: "linkedin",
          link: "https://www.linkedin.com/in/jserrano-gonzalez/",
        },
      ],
    },
    {
      nombre: "Yonathan",
      puesto: ["FullStack Developer.", "Devops."],
      img: "yona.png",
      socials: [
        {
          social: "youtube",
          link: "https://www.youtube.com/c/YonathanSuarez",
        },
        {
          social: "instagram",
          link: "https://www.instagram.com/yonathan.s.c/",
        },
        {
          social: "linkedin",
          link: "https://www.linkedin.com/in/yonathan-suarez-a357a6136/",
        },
      ],
    },
    {
      nombre: "Krey",
      puesto: ["Web Designer, Frontend"],
      img: "toyos.png",
      socials: [
        {
          social: "globe",
          link: "https://itskrey.com/",
        },
        {
          social: "instagram",
          link: "https://www.instagram.com/itskrey/",
        },
      ],
    },
  ];
  const [ t ] = useTranslation(['home']);
  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <h1 className="section-title rleft ">{t('MeetTheTeam')}</h1>
        </div>
      </div>
      <div className="row">
        {team.map((member) => (
          <div key={member.nombre} className=" p-4 member__card col-6 col-sm-4">
            <img src={require(`../assets/images/${member.img}`)} alt="" />
            <div className="d-flex mt-2">
              <div className="w-50 ">
                <h3>{member.nombre}</h3>
                {member.puesto.map((puesto) => (
                  <p className="m-0 ">{puesto}</p>
                ))}
              </div>
              <div className="d-flex flex-wrap  w-50 justify-content-end">
                {member.socials.map((social) => (
                  <div key={social.link} className="team__social-menu-item ">
                    <a href={social.link} target="_blank">
                      <i
                        className={
                          social.social == "globe"
                            ? `fas fa-${social.social}`
                            : `fab fa-${social.social}`
                        }
                      ></i>
                    </a>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Team;
